var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "#E7EDF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91543 11.6292V11.7624H10.5899V11.6292C10.5962 10.7813 10.9133 10.3876 11.63 9.98183C12.4609 9.50336 13 8.87349 13 7.87416C13 6.3782 11.7505 5.5 9.98097 5.5C8.35729 5.5 7.03171 6.31763 7 8.01952H8.80127C8.82664 7.3109 9.37844 6.9354 9.96829 6.92934C10.5835 6.9354 11.0782 7.32907 11.0719 7.93472C11.0782 8.49192 10.6533 8.86743 10.1078 9.20659C9.34672 9.66083 8.92178 10.1211 8.91543 11.6292ZM8.72516 13.4825C8.71247 14.0458 9.1945 14.5 9.7907 14.5C10.3552 14.5 10.8436 14.0458 10.8436 13.4825C10.8436 12.9253 10.3552 12.4711 9.7907 12.4771C9.1945 12.4711 8.71247 12.9253 8.72516 13.4825Z",
    fill: "#AEB7BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.33b3efb9a314302d2fd43f16bfdb5e46.svg";
export { ForwardRef as ReactComponent };